import { render, staticRenderFns } from "./LangChanger.vue?vue&type=template&id=c3a5d418&scoped=true&"
import script from "./LangChanger.vue?vue&type=script&lang=js&"
export * from "./LangChanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a5d418",
  null
  
)

export default component.exports